<!--
  Copyright (c) MobiFactory. All rights reserved.
  This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
  See LICENSE.txt file in the project root for full license information.
-->

<template>
  <div class="crm-item__container" @click="$emit(!isLinked ? 'linkToAccount' : 'navigateToMobiCRM', account.id)">
    <crm-account-badge
      class="crm-item__left"
      :type="account.type"
      :potential="account.potentialIndex"
      :rating="account.rating"
    />
    <div class="crm-item__body">
      <div class="crm-item__title">
        {{ account.companyName }}
      </div>
      <div class="crm-item__text">
        {{ account.referenceCode }}
      </div>
    </div>
    <div class="crm-item__right">
      <el-tooltip v-if="!isLinked" :content="$t('AccountPreview.AssociateTooltip')" placement="top">
        <i class="fal fa-link"></i>
      </el-tooltip>
      <el-tooltip v-else :content="$t('AccountPreview.AlreadyAssociatedTooltip')" placement="top">
        <i class="fal fa-check-circle"></i>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import CrmAccountBadge from "./AccountBadge";
import { defineComponent } from "vue";

export default defineComponent({
  name: "CrmAccountPreview",
  components: { CrmAccountBadge },
  props: {
    account: {
      type: Object,
      default: () => null,
    },
    isLinked: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["linkToAccount", "navigateToMobiCRM"],
});
</script>

<style lang="scss" scoped>
.fa-check-circle {
  color: $crm-color-checked;
}
</style>
